// src/pages/auth/FranquiciadoRegister.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { post } from '../../helpers/apiHelper';
import Swal from 'sweetalert2';

const FranquiciadoRegister = () => {
    const [searchParams] = useSearchParams();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [nombre, setNombre] = useState('');
    const [apellido, setApellido] = useState('');
    const navigate = useNavigate();
    const tiendaId = searchParams.get('tiendaId');

    useEffect(() => {
        const emailFromParams = searchParams.get('email');
        if (emailFromParams) {
            setEmail(emailFromParams);
        }
    }, [searchParams]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (password !== confirmPassword) {
            Swal.fire({
                title: 'Error',
                text: 'Las contraseñas no coinciden',
                icon: 'error',
                confirmButtonText: 'Aceptar'
            });
            return;
        }
        try {
            const response = await post('franquiciados-auth/register', { email, password, nombre, apellido, tiendaId });
            Swal.fire({
                title: response?.alreadyRegistered ? 'Cuenta existente' : 'Registro Exitoso',
                text: response?.alreadyRegistered
                    ? 'Este email ya tenía una cuenta de franquiciado. Hemos actualizado el acceso a la tienda. Inicia sesión para continuar.'
                    : 'Tu cuenta ha sido creada correctamente. Ahora puedes iniciar sesión.',
                icon: 'success',
                confirmButtonText: 'Aceptar'
            });
            navigate('/franquiciado/login');
        } catch (error) {
            Swal.fire({
                title: 'Error',
                text: error.message,
                icon: 'error',
                confirmButtonText: 'Aceptar'
            });
        }
    };

    return (
        <div className="flex justify-center items-center h-screen bg-gray-200">
            <form onSubmit={handleSubmit} className="bg-white p-6 rounded shadow-md">
                <h2 className="text-2xl mb-4">Registro de Franquiciado</h2>
                <div className="mb-4">
                    <label className="block mb-2">Nombre</label>
                    <input
                        type="text"
                        value={nombre}
                        onChange={(e) => setNombre(e.target.value)}
                        className="p-2 border border-gray-300 rounded w-full"
                        required
                    />
                </div>
                <div className="mb-4">
                    <label className="block mb-2">Apellido</label>
                    <input
                        type="text"
                        value={apellido}
                        onChange={(e) => setApellido(e.target.value)}
                        className="p-2 border border-gray-300 rounded w-full"
                        required
                    />
                </div>
                <div className="mb-4">
                    <label className="block mb-2">Email</label>
                    <input
                        type="email"
                        value={email}
                        className="p-2 border border-gray-300 rounded w-full"
                        readOnly
                    />
                </div>
                <div className="mb-4">
                    <label className="block mb-2">Contraseña</label>
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="p-2 border border-gray-300 rounded w-full"
                        required
                    />
                </div>
                <div className="mb-4">
                    <label className="block mb-2">Confirmar Contraseña</label>
                    <input
                        type="password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        className="p-2 border border-gray-300 rounded w-full"
                        required
                    />
                </div>
                <button type="submit" className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-700">
                    Registrar
                </button>
            </form>
        </div>
    );
};

export default FranquiciadoRegister;

